import React, { useRef } from 'react'

import { useLocation } from 'react-router-dom'

import { useAppState } from '@/states/app-state'

import { getToken } from '../../api/zendeskApi'
import { authService } from '../../core'

const ZENDESK_KEY = '214c9204-4b2d-4279-976a-8e0039539723'

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const WidgetZendesk = () => {
  const [loaded, setLoaded] = React.useState(false)
  const profile = useAppState((state) => state.profile)
  const currentCompanyId = profile?.conum
  const companyName = profile?.companyName
  const conumRef = useRef(currentCompanyId)
  const coNameRef = useRef(companyName)
  const loadedRef = useRef(loaded)
  const { pathname } = useLocation()

  const setChatCoInfo = async () => {
    if (conumRef.current && loadedRef.current) {
      window?.zE('messenger:set', 'conversationTags', [conumRef.current.toString(), coNameRef.current])
      window?.zE('messenger:set', 'conversationFields', [{ id: '360011866433', value: coNameRef.current }])
      window?.zE('messenger:set', 'conversationFields', [{ id: '360011866093', value: conumRef.current.toString() }])
    }
  }

  const handleScriptLoaded = () => {
    setLoaded(true)
    window?.zE('messenger', 'hide') // Start with the widget hidden
    window?.zE('messenger:on', 'open', function () {
      window?.zE('messenger', 'show') // Show the widget when user opens the chat
      setChatCoInfo()
    })
    window?.zE('messenger:on', 'close', function () {
      window?.zE('messenger', 'hide') // Hide the widget when user closes the chat
    })
  }

  React.useEffect(() => {
    if (loaded) return
    const script = document.createElement('script')
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`
    script.defer = true
    script.id = 'ze-snippet'
    script.addEventListener('load', handleScriptLoaded)
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [loaded, currentCompanyId])

  React.useEffect(() => {
    conumRef.current = currentCompanyId
    coNameRef.current = companyName
    loadedRef.current = loaded
    setChatCoInfo()
    if (loaded && currentCompanyId && authService.isCompanyAuthenticated()) {
      window?.zE('messenger', 'loginUser', async function (callback) {
        const token = await getToken()
        callback(token)
        setChatCoInfo()
      })
    } else if (loaded && !currentCompanyId) {
      window?.zE('messenger', 'logoutUser')
    }
  }, [currentCompanyId, companyName, loaded])

  React.useEffect(() => {
    const setZIndex = async () => {
      await sleep(500)
      window?.zE('messenger:set', 'zIndex', 1200)
    }
    if (loaded) setZIndex()
  }, [loaded])

  return null
}

export default WidgetZendesk
